import type {FC} from 'react';
import {
  Datagrid,
  DateField,
  DeleteButton,
  Edit,
  EditButton,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
} from 'react-admin';

const STATUS_CHOICES = [
  {id: 'DATA_PENDING', name: 'DATA_PENDING'},
  {id: 'DATA_UPLOADED', name: 'DATA_UPLOADED'},
];

export const UavPointCloudEdit: FC = () => (
  <Edit>
    <SimpleForm toolbar={<ToolbarDeleteOnly />}>
      <ReferenceInput source="forestMassUuid" reference="forest-masses">
        <SelectInput optionText="code" validate={[required()]} />
      </ReferenceInput>
      <ReferenceInput source="lidarTechnologyUuid" reference="lidar-technologies">
        <SelectInput optionText="name" validate={[required()]} />
      </ReferenceInput>
      <SelectInput source="status" choices={STATUS_CHOICES} validate={[required()]} />
      <TextInput source="flightDate" validate={[required()]} />
      <NumberInput source="height" validate={[required()]} />
      <NumberInput source="speed" validate={[required()]} />
      <NumberInput source="overlapPercentage" validate={[required()]} />
      <TextInput source="comments" multiline />
    </SimpleForm>
  </Edit>
);

const ToolbarDeleteOnly: FC = (props) => (
  <Toolbar {...props}>
    <DeleteButton />
  </Toolbar>
);

export const UavPointCloudDatagrid: FC = () => (
  <Datagrid rowClick="edit">
    <TextField source="status" />
    <DateField source="flightDate" label="Flight Date" />
    <NumberField source="height" />
    <NumberField source="speed" />
    <NumberField source="overlapPercentage" label="Overlap %" />
    <ReferenceField source="lidarTechnologyUuid" reference="lidar-technologies" label="Lidar Tech">
      <TextField source="name" />
    </ReferenceField>
    <EditButton />
    <DeleteButton />
  </Datagrid>
);
